import React from 'react';
//import {MovieCastDataFetch} from './MovieCastDataFetch.js';
import MovieCastData from './MovieCastData.js';

const MovieCastDetail = props => {
    //const {MovieCastData, loading, error} = MovieCastDataFetch();
    //if (loading) return <div>Loading...</div>;
    //if (error) return <div>{error}</div>;
    console.log("personId: " + props.personId);
    //const person = MovieCastData.find(person => person.id === 91606);
    const person = MovieCastData.find(person => person.id === props.personId);

    if(!person){
      return <div>Kipsaté</div>; //null;
    }
  
    return(
    <>
      <img src={"https://www.marchouben.nl/afbeeldingen/" + person.profile_path} alt="" height="220"/>
      <h1>{person.id}</h1>
      <h3>{person.name}</h3>
      <h4>{person.gender === 1 ? "Vrouw" : "Man"}</h4>
      <h3>{person.character}</h3>
      <p>
        {person.description}
      </p>
      <p>
        {person.profile_path}
      </p>
    </>
  );
  };
  
  export default MovieCastDetail;